import React from "react";
import "./About.css";

const features = [
  { icon: "🇹🇳", text: "Made in TamilNadu", sub: "Locally Crafted",  accent: "#d97706" },
  { icon: "👍",   text: "Assured Quality",   sub: "100% Genuine",     accent: "#8353C6" },
  { icon: "🚚",   text: "Free Shipping",     sub: "On orders ₹499+",  accent: "#2563eb" },
  { icon: "📦",   text: "7 Day Returns",     sub: "Hassle-free",      accent: "#16a34a" },
  { icon: "🖨️",  text: "Custom Printing",   sub: "Min. 1 meter",     accent: "#db2777" },
];

const About = () => {
  return (
    <div className="about-strip">
      {features.map((feature, index) => (
        <React.Fragment key={index}>
          <div className="about-badge">
            <span
              className="about-icon-wrap"
              style={{
                background: feature.accent + "18",
                borderColor: feature.accent + "55",
              }}
            >
              <span className="about-icon">{feature.icon}</span>
            </span>
            <div className="about-info">
              <span className="about-label">{feature.text}</span>
              <span className="about-sub">{feature.sub}</span>
            </div>
          </div>
          {index < features.length - 1 && (
            <div className="about-divider" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default About;
